export enum KnowledgeLabRoleId {
    Owner = 0,
    Contributor = 1,
    Reader = 2
}